'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = require('semantic-ui-react');

var _dyzioModal = require('../dyzio-modal');

var _dyzioModal2 = _interopRequireDefault(_dyzioModal);

var _demographicsAgeGraph = require('../demographics-age-graph');

var _demographicsAgeGraph2 = _interopRequireDefault(_demographicsAgeGraph);

var _demographicsGenderGraph = require('../demographics-gender-graph');

var _demographicsGenderGraph2 = _interopRequireDefault(_demographicsGenderGraph);

var _youtubeDemographicsCountriesTable = require('../youtube-demographics-countries-table');

var _youtubeDemographicsCountriesTable2 = _interopRequireDefault(_youtubeDemographicsCountriesTable);

var _demographicsYoutubeDataTable = require('../demographics-youtube-data-table');

var _demographicsYoutubeDataTable2 = _interopRequireDefault(_demographicsYoutubeDataTable);

var _followersBarChart = require('../followers-bar-chart');

var _followersBarChart2 = _interopRequireDefault(_followersBarChart);

var _youtubeDataTabs = require('./youtube-data-tabs');

var _youtubeDataTabs2 = _interopRequireDefault(_youtubeDataTabs);

var _formatting = require('../../utils/formatting');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noBottomPadding = {
  paddingBottom: 0
};

var chartWrapperStyles = {
  width: '100%'
};

var dividerStyle = {
  marginTop: 5,
  marginBottom: 5
};

var notificationStyle = {
  paddingTop: 100,
  paddingBottom: 100
};

var messageStyle = { color: 'grey', fontSize: 16 };

var modalLinkStyle = {
  cursor: 'pointer'
};

var YoutubeProfileDataLarge = function YoutubeProfileDataLarge(props) {
  var hasFullEngagementDataLink = props.hasFullEngagementDataLink,
      toggleYoutubeDemographicsModalState = props.toggleYoutubeDemographicsModalState,
      isYouTubeCompliance = props.isYouTubeCompliance,
      _props$influencer = props.influencer,
      countHistory = _props$influencer.countHistory,
      youtube = _props$influencer.youtube,
      youtubeData = _props$influencer.youtubeData,
      name = _props$influencer.name,
      thumbnail = _props$influencer.thumbnail,
      youtubeDemographicsModalOpen = props.youtubeDemographicsModalOpen,
      missingAPILink = props.missingAPILink,
      apiInfluencer = props.apiInfluencer;


  var youtubeDataExists = youtubeData && _lodash2.default.size(youtubeData) > 0;

  var hasYoutubeHandle = _lodash2.default.isString(youtube);
  var lastMonthHistory = _lodash2.default.slice(countHistory, -30);

  var chartProps = {
    rgbColorCode: '#ff0000',
    label: 'subscribers',
    labels: _lodash2.default.map(lastMonthHistory, function (item) {
      return (0, _moment2.default)(item.createdDate).format('MMM D');
    }),
    values: _lodash2.default.map(lastMonthHistory, 'youtubeCount')
  };

  var percentageChange = void 0;
  if (lastMonthHistory && lastMonthHistory.length > 10) {
    var first = _lodash2.default.head(lastMonthHistory).youtubeCount;
    var last = _lodash2.default.last(lastMonthHistory).youtubeCount;
    percentageChange = (last - first) / first;
  }

  var avgComments = void 0;
  var thirtyDayData = void 0;

  if (apiInfluencer) {
    var latestVideos = apiInfluencer.latestYoutubeVideos;
    var sumComments = _lodash2.default.sumBy(latestVideos, function (lv) {
      return parseInt(_lodash2.default.get(lv, 'statistics.commentCount', 0), 10);
    });
    avgComments = sumComments / latestVideos.length;

    var channelStatistics = apiInfluencer.channelStatistics;

    var orderedStats = _lodash2.default.orderBy(channelStatistics, 'collectedDate', 'desc');
    var latestStat = _lodash2.default.head(orderedStats);
    var earliestStat = orderedStats[30] || _lodash2.default.last(orderedStats);
    thirtyDayData = {
      subscriberChange: latestStat.subscriberCount - earliestStat.subscriberCount,
      viewChange: latestStat.viewCount - earliestStat.viewCount,
      videoChange: latestStat.videoCount - earliestStat.videoCount,
      dayChange: (0, _moment2.default)(latestStat.collectedDate).diff((0, _moment2.default)(earliestStat.collectedDate), 'days')
    };
  }

  return _react2.default.createElement(
    _semanticUiReact.Segment,
    { loading: props.loading, color: 'red' },
    _react2.default.createElement(
      'h3',
      null,
      !isYouTubeCompliance && _react2.default.createElement(_semanticUiReact.Icon, { name: 'youtube', color: 'red' }),
      'YouTube'
    ),
    _react2.default.createElement(_semanticUiReact.Divider, null),
    _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { columns: 3, style: noBottomPadding },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 3 },
          hasYoutubeHandle && apiInfluencer && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_semanticUiReact.Image, {
              src: thumbnail,
              circular: true,
              centered: true,
              size: 'small'
            }),
            _react2.default.createElement(
              _semanticUiReact.Table,
              { basic: 'very', fluid: true, textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    apiInfluencer.name,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'grey' })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(_semanticUiReact.Label, { color: 'blue', basic: true, content: apiInfluencer.category })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.videoCount),
                    ' videos'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    (0, _formatting.commaFormatted)(apiInfluencer.aggregateYoutubeChannelStatistics.subscriberCount),
                    ' subscribers'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 8 },
          hasYoutubeHandle && _react2.default.createElement(
            'div',
            { className: 'chart-wrapper-print' },
            _react2.default.createElement(_followersBarChart2.default, (0, _extends3.default)({}, chartProps, {
              percentageRange: 0.5
            }))
          ),
          !hasYoutubeHandle && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h2', icon: true, textAlign: 'center', style: notificationStyle },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'minus', color: 'orange', circular: true }),
              _react2.default.createElement(
                _semanticUiReact.Header.Content,
                { style: messageStyle },
                'no Youtube channel',
                _react2.default.createElement('br', null),
                'for this influencer'
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 5 },
          hasYoutubeHandle && !props.data && !props.loading && props.error && _react2.default.createElement(
            _semanticUiReact.Message,
            { error: true },
            'could not load Youtube data'
          ),
          hasYoutubeHandle && !props.data && !props.loading && missingAPILink && _react2.default.createElement(
            _semanticUiReact.Message,
            { warning: true },
            'missing api link'
          ),
          hasYoutubeHandle && apiInfluencer && _react2.default.createElement(_youtubeDataTabs2.default, {
            percentageChange: percentageChange,
            apiInfluencer: apiInfluencer,
            avgComments: avgComments,
            isYouTubeCompliance: isYouTubeCompliance,
            thirtyDayData: thirtyDayData
          })
        )
      ),
      youtubeDataExists && _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { textAlign: 'center', style: noBottomPadding },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(
            'h2',
            null,
            'Audience Demographics and Regions (last 30 days)',
            _react2.default.createElement(_semanticUiReact.Popup, {
              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', color: 'orange' }),
              content: 'Private data collected from Youtube Insights API'
            })
          )
        )
      ),
      youtubeDataExists && _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { textAlign: 'center' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 3 },
          _react2.default.createElement(
            'h5',
            null,
            'Viewing by Gender'
          ),
          _react2.default.createElement(
            'div',
            { className: 'chart-wrapper-print' },
            _react2.default.createElement(_demographicsGenderGraph2.default, youtubeData)
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'h5',
            null,
            'Video View Duration'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table,
            { singleLine: true, basic: 'very', compact: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'Avg. Watch Time:'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                youtubeData && youtubeData.watchTimeMetrics && _react2.default.createElement(
                  'span',
                  null,
                  _moment2.default.utc(youtubeData.watchTimeMetrics.data.averageViewDuration * 1000).format('mm[m] ss[s]')
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                'Avg. View Percentage:'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                youtubeData && youtubeData.watchTimeMetrics && _react2.default.createElement(
                  'span',
                  null,
                  _lodash2.default.round(youtubeData.watchTimeMetrics.data.averageViewPercentage),
                  ' %'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 8 },
          _react2.default.createElement(
            'h5',
            null,
            'Channel demographic by gender / age'
          ),
          _react2.default.createElement(
            'div',
            { className: 'chart-wrapper-print' },
            _react2.default.createElement(
              'div',
              { className: 'chart-wrapper-print' },
              _react2.default.createElement(_demographicsAgeGraph2.default, youtubeData)
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 5 },
          _react2.default.createElement(
            'h5',
            null,
            'Where are they watching?'
          ),
          _react2.default.createElement(
            'div',
            { className: 'chart-wrapper-print padding-top-on-print' },
            _react2.default.createElement(_youtubeDemographicsCountriesTable2.default, youtubeData)
          ),
          hasFullEngagementDataLink && _react2.default.createElement(
            'a',
            { style: modalLinkStyle, onClick: toggleYoutubeDemographicsModalState },
            'View full engagement data'
          )
        )
      )
    ),
    youtubeDemographicsModalOpen && _react2.default.createElement(
      _dyzioModal2.default,
      {
        headerText: 'Full Channel Engagement Data (last 30 days)',
        size: 'fullscreen',
        onClose: toggleYoutubeDemographicsModalState
      },
      _react2.default.createElement(_demographicsYoutubeDataTable2.default, youtubeData)
    )
  );
};

YoutubeProfileDataLarge.defaultProps = {
  hasFullEngagementDataLink: true
};

exports.default = YoutubeProfileDataLarge;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/youtube-profile-data-large/index.js
 ** module id = 2600
 ** module chunks = 0
 **/